import { useContext } from "react"
import { useNavigate } from "react-router-dom"
import { PageHeader, ProfileCard, SettingsLayout } from "@/components"
import { AppContext } from "../providers/AppProvider.jsx"

export default function SettingsProfile() {
	const navigate = useNavigate()
	const { session } = useContext(AppContext)

	return (
		<SettingsLayout onBack={() => navigate(-1)}>
			<div className="max-w-lg">
				<PageHeader title="Profile" description="Your account details." />
				{session ? (
					<>
						<ProfileCard
							entries={[
								{ label: "Name", value: session.name },
								{ label: "Email", value: session.email },
							]}
						/>
						{session.internal && (
							<p className="mt-4 border-l-4 border-info pl-4 text-body text-muted-foreground">
								You are connected through Think Huge VPN.
							</p>
						)}
					</>
				) : (
					<p className="text-body text-muted-foreground">No session data available</p>
				)}
			</div>
		</SettingsLayout>
	)
}
